var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_634_5735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9565 11.8506H17.9565V13.8506H15.9565V11.8506ZM15.9565 15.8506H17.9565V21.8506H15.9565V15.8506ZM16.9565 6.85059C11.4365 6.85059 6.95654 11.3306 6.95654 16.8506C6.95654 22.3706 11.4365 26.8506 16.9565 26.8506C22.4765 26.8506 26.9565 22.3706 26.9565 16.8506C26.9565 11.3306 22.4765 6.85059 16.9565 6.85059ZM16.9565 24.8506C12.5465 24.8506 8.95654 21.2606 8.95654 16.8506C8.95654 12.4406 12.5465 8.85059 16.9565 8.85059C21.3665 8.85059 24.9565 12.4406 24.9565 16.8506C24.9565 21.2606 21.3665 24.8506 16.9565 24.8506Z",
    fill: "#A20990"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_634_5735"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.956543,
    y: 0.850586,
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d29d0a405d4c6cb99077972b1d3e8b56.svg";
export { ForwardRef as ReactComponent };